module.exports = __webpack_public_path__ + "static/img/mktImg.dfd18a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mktImg.png
// module id = TA+l
// module chunks = 2